// extracted by mini-css-extract-plugin
export default {"Project":"Project_Project__uOwnw","ProjectName":"Project_ProjectName__yHr0f","ProjectImage":"Project_ProjectImage__P2OKQ","ProjectButton":"Project_ProjectButton__wZ-Ln"};